export default {
  checkInterval: 'Interval kontroly',
  newCommitCheckInterval: 'Interval kontroly nových commitů',
  schedule: 'Harmonogram',
  newSchedule: 'Nový harmonogram',
  deleteSchedule: 'Odstranit harmonogram',
  editSchedule: 'Upravit harmonogram',
  backup: 'Zálohovat projekt',
  downloadTheProjectBackupFile: 'Stáhnout soubor zálohy projektu.',
  restoreProject: 'Obnovit projekt...',
  incorrectUsrPwd: 'Nesprávné přihlašovací jméno nebo heslo',
  askDeleteUser: 'Opravdu chcete odstranit tohoto uživatele?',
  askDeleteTemp: 'Opravdu chcete odstranit tuto šablonu?',
  askDeleteEnv: 'Opravdu chcete odstranit tuto skupinu proměnných?',
  askDeleteInv: 'Opravdu chcete odstranit tento inventář?',
  askDeleteKey: 'Opravdu chcete odstranit tento klíč?',
  askDeleteRepo: 'Opravdu chcete odstranit tento repozitář?',
  askDeleteProj: 'Opravdu chcete odstranit tento projekt?',
  askDeleteTMem: 'Opravdu chcete odstranit tohoto člena týmu?',
  askDeleteSchedule: 'Opravdu chcete odstranit tento harmonogram?',
  edit: 'Upravit',
  nnew: 'Nový',
  keyFormSshKey: 'SSH klíč',
  keyFormLoginPassword: 'Přihlášení heslem',
  keyFormNone: 'Žádný',
  incorrectUrl: 'Nesprávná URL',
  username: 'Uživatelské jméno',
  username_required: 'Uživatelské jméno je povinné',
  dashboard: 'Přehled',
  history: 'Historie',
  activity: 'Aktivita',
  settings: 'Nastavení',
  signIn: 'Přihlásit se',
  password: 'Heslo',
  changePassword: 'Změnit heslo',
  editUser: 'Upravit uživatele',
  newProject: 'Nový projekt',
  close: 'Zavřít',
  newProject2: 'Nový projekt...',
  demoMode: 'DEMO REŽIM',
  task: 'Úloha #{expr}',
  youCanRunAnyTasks: 'Můžete spouštět libovolné úlohy',
  youHaveReadonlyAccess: 'Máte přístup pouze pro čtení',
  taskTemplates: 'Šablony úloh',
  inventory: 'Inventář',
  environment: 'Skupiny proměnných',
  keyStore: 'Úložiště klíčů',
  repositories: 'Repozitáře',
  darkMode: 'Tmavý režim',
  team: 'Tým',
  more: 'Další',
  pin: 'Připnout do postranního panelu',
  unpin: 'Odepnout z postranního panelu',
  editMenu: 'Upravit nabídku',
  finishEditingMenu: 'Hotovo',
  users: 'Uživatelé',
  editAccount: 'Upravit účet',
  signOut: 'Odhlásit se',
  error: 'Chyba',
  refreshPage: 'Obnovit stránku',
  relogin: 'Znovu se přihlásit',
  howToFixSigninIssues: 'Jak vyřešit problémy s přihlášením',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Nejprve potřebujete přístup k serveru, na kterém běží Semaphore.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Chcete-li zobrazit existující uživatele, spusťte na serveru následující příkaz:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'Heslo existujícího uživatele můžete změnit takto:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Nebo vytvořte nového administrátora:',
  close2: 'Zavřít',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Nemáte účet nebo se nemůžete přihlásit?',
  password2: 'Heslo',
  cancel: 'Zrušit',
  noViews: 'Žádná zobrazení',
  addView: 'Přidat zobrazení',
  editEnvironment: 'Upravit skupinu proměnných',
  deleteEnvironment: 'Odstranit skupinu proměnných',
  newEnvironment: 'Nová skupina',
  environmentName: 'Název skupiny',
  dockerImage: 'Docker image runneru (volitelné)',
  extraVariables: 'Doplňkové proměnné',
  enterExtraVariablesJson: 'Zadejte doplňkové proměnné ve formátu JSON...',
  environmentVariables: 'Proměnné prostředí',
  enterEnvJson: 'Zadejte proměnné prostředí ve formátu JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Proměnné prostředí i doplňkové proměnné musí být platný JSON. Příklad:',
  dashboard2: 'Přehled',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: '<%= htmlWebpackPlugin.options.title %> bez zapnutého JavaScriptu nefunguje správně. Pro pokračování JavaScript zapněte.',
  deleteInventory: 'Odstranit inventář',
  newInventory: 'Nový inventář',
  name: 'Název',
  userCredentials: 'Přihlašovací údaje uživatele',
  sudoCredentialsOptional: 'Přihlašovací údaje sudo (volitelné)',
  type: 'Typ',
  pathToInventoryFile: 'Cesta k souboru inventáře',
  enterInventory: 'Zadejte inventář...',
  staticInventoryExample: 'Příklad statického inventáře:',
  staticYamlInventoryExample: 'Příklad statického inventáře YAML:',
  keyName: 'Název klíče',
  loginOptional: 'Přihlašovací jméno (volitelné)',
  usernameOptional: 'Uživatelské jméno (volitelné)',
  privateKey: 'Soukromý klíč',
  override: 'Přepsat',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Tento typ klíče použijte pro HTTPS repozitáře a pro playbooky využívající připojení bez SSH.',
  deleteKey: 'Odstranit klíč',
  newKey: 'Nový klíč',
  create: 'Vytvořit',
  newTask: 'Nová úloha',
  cantDeleteThe: '{objectTitle} nelze odstranit',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: '{objectTitle} nelze odstranit, protože jej používají níže uvedené prostředky',
  projectName: 'Název projektu',
  allowAlertsForThisProject: 'Povolit upozornění pro tento projekt',
  telegramChatIdOptional: 'ID chatu Telegramu (volitelné)',
  maxNumberOfParallelTasksOptional: 'Maximální počet paralelních úloh (volitelné)',
  deleteRepository: 'Odstranit repozitář',
  newRepository: 'Nový repozitář',
  urlOrPath: 'URL nebo cesta',
  absPath: 'absolutní cesta',
  branch: 'Větev / tag',
  accessKey: 'Přístupový klíč',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Přihlašovací údaje pro přístup k repozitáři Git. Mělo by jít o:',
  ifYouUseGitOrSshUrl: 'pokud používáte URL Git nebo SSH.',
  ifYouUseHttpsOrFileUrl: 'pokud používáte URL HTTPS nebo souboru.',
  none: 'Žádný',
  ssh: 'SSH',
  deleteProject: 'Odstranit projekt',
  save: 'Uložit',
  deleteProject2: 'Odstranit projekt',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Odstranění projektu nelze vrátit zpět. Ujistěte se, že jej opravdu chcete odstranit.',
  clear_cache: 'Vymazat mezipaměť',
  clear_cache_message: 'Odstranit všechny soubory mezipaměti související s tímto projektem. Tuto akci nelze vrátit zpět.',
  name2: 'Název *',
  title: 'Nadpis *',
  description: 'Popis',
  required: 'Povinné',
  key: '{expr}',
  surveyVariables: 'Vstupní proměnné',
  addVariable: 'Přidat proměnnou',
  vaultName: 'ID Vaultu (volitelné)',
  vaultNameDefault: 'Může existovat pouze jeden název `default` (prázdný)',
  default_value: 'Výchozí hodnota',
  vaultNameUnique: 'Musí být jedinečné',
  vaultTypePassword: 'Heslo',
  vaultTypeScript: 'Klientský skript',
  vaultScript: 'Cesta ke skriptu',
  vaultScriptRequired: 'Cesta ke skriptu je povinná',
  vaultScriptClientRequired: 'Cesta ke skriptu musí končit řetězcem \'-client\' a příponou',
  vaults: 'Vaulty',
  vaultAdd: 'Přidat Vault',
  vaultRequired: 'Heslo Vaultu je povinné',
  columns: 'Sloupce',
  buildVersion: 'Verze sestavení',
  messageOptional: 'Zpráva (volitelné)',
  debug: 'Ladění',
  dryRun: 'Zkušební běh',
  diff: 'Rozdíl',
  advanced: 'Pokročilé',
  hide: 'Skrýt',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Chcete-li povolit přepsání argumentu CLI, upravte nastavení šablony úlohy',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'Argumenty CLI (pole JSON). Příklad: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Spuštěno',
  author: 'Autor',
  duration: 'Doba trvání',
  stop: 'Zastavit',
  forceStop: 'Vynutit zastavení',
  stopAll: 'Zastavit vše',
  stopAllTasks: 'Zastavit všechny úlohy',
  askStopAllTasks: 'Opravdu chcete zastavit všechny úlohy?',
  forceStopAllTasks: 'Vynutit zastavení všech úloh',
  askForceStopAllTasks: 'Opravdu chcete vynutit zastavení všech úloh?',
  raw_log: 'Neformátovaný log',
  confirmTask: 'Potvrdit',
  deleteTeamMember: 'Odstranit člena týmu',
  team2: 'Tým',
  newTeamMember: 'Nový člen týmu',
  user: 'Uživatel',
  administrator: 'Administrátor',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Určuje počáteční verzi artefaktu. Každé spuštění zvýší verzi artefaktu.',
  forMoreInformationAboutBuildingSeeThe: 'Další informace o sestavení najdete v',
  taskTemplateReference: 'Referenci šablony úlohy',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Určuje, který artefakt má být při spuštění úlohy nasazen.',
  forMoreInformationAboutDeployingSeeThe: 'Další informace o nasazení najdete v',
  taskTemplateReference2: 'Referenci šablony úlohy',
  definesAutorunSchedule: 'Určuje harmonogram automatického spouštění.',
  forMoreInformationAboutCronSeeThe: 'Další informace o systému cron najdete v',
  cronExpressionFormatReference: 'Referenci formátu výrazu cron',
  startVersion: 'Počáteční verze',
  example000: 'Příklad: 0.0.0',
  buildTemplate: 'Šablona sestavení',
  autorun: 'Automatické spuštění',
  playbookFilename: 'Cesta k souboru playbooku *',
  exampleSiteyml: 'Příklad: deploy/site.yml',
  inventory2: 'Inventář *',
  repository: 'Repozitář',
  environment3: 'Skupiny proměnných *',
  environmentsHint: 'Proměnné z vybraných skupin se sloučí v uvedeném pořadí; při konfliktu mají přednost pozdější skupiny.',
  vaultPassword: 'Heslo Vaultu',
  vaultPassword2: 'Heslo Vaultu',
  view: 'Zobrazení',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Automaticky spustit úlohu, pokud byl nalezen nový commit v Gitu',
  repository2: 'Repozitář',
  cronChecksNewCommitBeforeRun: 'Cron před spuštěním zkontroluje nový commit',
  readThe: 'Přečtěte si',
  toLearnMoreAboutCron: 'a zjistěte více o systému Cron.',
  suppressSuccessAlerts: 'Potlačit oznámení o úspěchu',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'Argumenty CLI (pole JSON). Příklad: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'Argumenty CLI',
  docs: 'dokumentaci',
  editViews: 'Upravit zobrazení',
  newTemplate: 'Nová šablona',
  taskTemplates2: 'Šablony úloh',
  all: 'Vše',
  notLaunched: 'Nespuštěno',
  by: 'od uživatele {user_name}',
  editTemplate: 'Upravit šablonu',
  newTemplate2: 'Nová šablona',
  deleteTemplate: 'Odstranit šablonu',
  playbook: 'Playbook',
  email: 'E-mail',
  adminUser: 'Administrátor',
  sendAlerts: 'Odesílat upozornění',
  deleteUser: 'Odstranit uživatele',
  newUser: 'Nový uživatel',
  re: 'Znovu {getActionButtonTitle}',
  teamMember: '{expr} člen týmu',
  taskId: 'ID úlohy',
  status: 'Stav',
  start: 'Spustit',
  actions: 'Akce',
  alert: 'Upozornění',
  admin: 'Administrátor',
  role: 'Role',
  external: 'Externí',
  time: 'Čas',
  path: 'Cesta',
  gitUrl: 'URL Gitu',
  sshKey: 'SSH klíč',
  lastTask: 'Poslední úloha',
  task2: 'Úloha',
  build: 'Sestavit',
  deploy: 'Nasadit',
  run: 'Spustit',
  add: 'Přidat',
  password_required: 'Heslo je povinné',
  name_required: 'Název je povinný',
  user_credentials_required: 'Přihlašovací údaje uživatele jsou povinné',
  type_required: 'Typ je povinný',
  path_required: 'Cesta k souboru inventáře je povinná',
  private_key_required: 'Soukromý klíč je povinný',
  project_name_required: 'Název projektu je povinný',
  repository_required: 'Repozitář je povinný',
  branch_required: 'Větev nebo tag jsou povinné',
  key_required: 'Klíč je povinný',
  user_required: 'Uživatel je povinný',
  build_version_required: 'Verze sestavení je povinná',
  title_required: 'Nadpis je povinný',
  isRequired: 'je povinné',
  mustBeInteger: 'Musí být celé číslo',
  mustBe0OrGreater: 'Musí být 0 nebo více',
  start_version_required: 'Počáteční verze je povinná',
  playbook_filename_required: 'Název souboru playbooku je povinný',
  inventory_required: 'Inventář je povinný',
  environment_required: 'Skupina proměnných je povinná',
  email_required: 'E-mail je povinný',
  build_template_required: 'Šablona sestavení je povinná',
  Task: 'Úloha',
  Build: 'Sestavení',
  Deploy: 'Nasazení',
  Run: 'Spuštění',
  ReBuild: 'Znovu sestavit',
  ReDeploy: 'Znovu nasadit',
  ReRun: 'Spustit znovu',
  CreateDemoProject: 'Vytvořit ukázkový projekt',
  LeaveProject: 'Opustit projekt',
  integration: 'Integrace',
  integrations: 'Integrace',
  NewIntegration: 'Nová integrace',
  EditIntegration: 'Upravit integraci',
  DeleteIntegration: 'Odstranit integraci',
  DeleteIntegrationMsg: 'Opravdu chcete odstranit tuto integraci?',
  AddAlias: 'Přidat alias',
  LoadAlias: 'Načítání aliasů...',
  globalAlias: 'Použít alias projektu',
  matcher: 'Porovnání',
  matchType: 'Typ porovnání',
  newMatcher: 'Nové porovnání',
  matchMethod: 'Metoda porovnání',
  matchBodyDataType: 'Datový typ těla požadavku',
  extractValue: 'Extrahovat hodnotu',
  newExtractedValue: 'Nová extrahovaná hodnota',
  extractedValueSource: 'Zdroj hodnoty',
  matchKey: 'Klíč',
  matchValue: 'Hodnota',
  matchOn: 'Porovnat podle',
  global: 'Globální',
  synchronized: 'synchronizováno',
  default: 'Výchozí',
  project: 'Projekt',
  runners: 'Runnery',
  clusterDashboard: 'Přehled HA clusteru',
  clusterOverview: 'Přehled',
  haEnabled: 'Režim HA',
  haDisabledBanner: 'Režim HA je vypnutý — zobrazuje se pouze místní fond úloh.',
  nodes: 'Uzly',
  alive: 'Aktivní',
  dead: 'Nedostupný',
  thisNode: 'tento uzel',
  lastHeartbeat: 'Poslední heartbeat',
  startedAt: 'Spuštěno v',
  redisStatus: 'Redis',
  connected: 'Připojeno',
  usedMemory: 'Využitá paměť',
  redisMemoryChart: 'Využitá paměť (v reálném čase)',
  totalKeys: 'Celkem klíčů',
  keyGroups: 'Skupiny klíčů',
  taskRecords: 'Záznamy úloh',
  queue: 'Fronta',
  running: 'Probíhající',
  activeByProject: 'Aktivní podle projektu',
  aliases: 'Aliasy',
  claims: 'Claims',
  owningNode: 'Uzel',
  clearTasksFromRedis: 'Vymazat úlohy z Redisu',
  clearTasksTitle: 'Vymazat úlohy z Redisu',
  clearTasksWarning: 'Vymazání záznamů Running nebo Claims může narušit synchronizaci uzlů clusteru. Použijte pouze při obnově ze zablokovaného stavu.',
  clearTasksGroups: 'Vyberte skupiny záznamů k vymazání:',
  runtimeFields: 'Provozní pole',
  newRunner: 'Nový runner',
  enabled: 'Povoleno',
  scheduleNextRun: 'Příští spuštění',
  maxNumberOfParallelTasks: 'Maximální počet paralelních úloh',
  runnerUsage: 'Použití:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Token:',
  editRunner: 'Upravit runner',
  deleteRunner: 'Odstranit runner',
  newRunnerToken: 'Nový runner',
  register: 'Registrovat',
  unregisteredRunnerHint: 'Runner bude vytvořen bez tokenu. Poté pro něj můžete vygenerovat jednorázový registrační token a později jej použít k registraci runneru.',
  runnerRegistrationToken: 'Nový runner',
  registrationToken: 'Registrační token:',
  registrationTokenHint: 'Tento jednorázový token se zobrazí pouze jednou a jeho platnost vyprší za 1 hodinu. Použijte jej k registraci runneru.',
  howToRegister: 'Postup registrace',
  runnerCreated: 'Runner vytvořen',
  regenerateRegistrationToken: 'Znovu vygenerovat registrační token',
  askResetRunnerRegistration: 'Tento runner je registrován. Opětovné vygenerování tokenu jeho registraci resetuje: současný token přestane fungovat a runner bude offline, dokud se znovu nezaregistruje pomocí nového tokenu. Pokračovat?',
  askDeleteRunner: 'Opravdu chcete odstranit runner {runner}?',
  roles_only_enterprise: 'Role jsou dostupné pouze v edici <b>Enterprise</b>.',
  ha_only_enterprise: 'Vysoká dostupnost je dostupná pouze v edici <b>Enterprise</b>.',
  project_runners_only_pro: 'Runnery na úrovni projektu jsou dostupné pouze uživatelům verze <b>PRO</b>.',
  secret_storage_only_pro: 'Úložiště tajných údajů jsou dostupná pouze uživatelům verze <b>PRO</b>.',
  foss_runners_limited: 'Open-source verze má omezené funkce; plná funkčnost je k dispozici ve verzi <b>PRO</b>.',
  learn_more_about_pro: 'Další informace',
  upgrade_to_pro: 'Upgradovat',
  contact_admin_to_upgrade: 'Pro aktivaci funkcí PRO kontaktujte správce.',
  contact_admin_to_upgrade_enterprise: 'Pro aktivaci funkcí Enterprise kontaktujte správce.',
  projectRestoreResult: 'Výsledky obnovení projektu',
  projectWithNameRestored: 'Projekt {projectName} byl úspěšně obnoven.',
  pleaseUpdateAccessKeys: 'Před spuštěním úloh je aktualizujte.',
  emptyKeysRestored: 'Přidány prázdné klíče: {emptyKeys}.',
  template: 'Šablona',
  aliasUrlCopied: 'URL aliasu byla zkopírována do schránky.',
  yes: 'Ano',
  activeTasks: 'Aktivní úlohy',
  taskLocation: 'Umístění',
  empty: 'Prázdné',
  noValues: 'Žádné hodnoty',
  addArg: 'Přidat argument',
  status_success: 'Úspěšné',
  status_failed: 'Neúspěšné',
  status_stopped: 'Zastaveno',
  api_tokens: 'API tokeny',
  tokenName: 'Název tokenu',

  // Terraform/OpenTofu/Terragrunt
  auto_approve: 'Automaticky schválit',
  auto_destroy: 'Povolit odstranění infrastruktury',
  terraform_override_backend: 'Přepsat nastavení backendu',
  terraform_backend_filename: 'Název souboru backendu (výchozí: backend.tf)',
  terraform_invalid_backend_filename: 'Neplatný název souboru backendu',

  // Ansible
  tag: 'Tag',
  tag_required: 'Tag je povinný',
  allowInventoryInTask: 'Inventář',
  allowLimitInTask: 'Limit',
  addLimit: 'Přidat limit',
  allowDebug: 'Ladění',
  addTag: 'Přidat tag',
  skipTags: 'Přeskočit tagy',
  addSkippedTag: 'Přidat přeskočený tag',
  tags: 'Tagy',
  limit: 'Limit',
  runner_tag: 'Tag runneru',
  allow_parallel_tasks: 'Povolit paralelní úlohy',
  task_prompts: 'Parametry při spuštění',
  template_advanced: 'Pokročilé možnosti',
  template_app_options: 'Možnosti aplikace {app}',
  template_app_prompts: 'Parametry {app} při spuštění',
  general_settings: 'Obecné',
  danger_zone_settings: 'Nebezpečná zóna',
  project_stats: 'Statistiky',
  allow_override_branch: 'Větev',
  template_common_options: 'Společné možnosti',
  template_tasks: 'Úlohy',
  template_details: 'Podrobnosti',
  template_tf_workspaces: 'Workspaces',

  // Role-related translations
  slug: 'Slug',
  slug_required: 'Slug je povinný',
  slugHint: 'Jedinečný identifikátor (pouze malá písmena, číslice, podtržítka a spojovníky)',
  invalidSlugFormat: 'Slug musí obsahovat pouze malá písmena, číslice, podtržítka a spojovníky',
  permissions: 'Oprávnění',
  canRunProjectTasks: 'Může spouštět úlohy projektu',
  canUpdateProject: 'Může aktualizovat projekt',
  canManageProjectResources: 'Může spravovat prostředky projektu',
  canManageProjectUsers: 'Může spravovat uživatele projektu',
  newRole: 'Nová role',
  editRole: 'Upravit roli',
  deleteRole: 'Odstranit roli',
  askDeleteRole: 'Opravdu chcete odstranit tuto roli?',
  Roles: 'Role',
  role_required: 'Role je povinná',
  templatePermission: 'Oprávnění k šablonám',

  // System Info Dialog
  systemInfo: 'Systémové informace',
  system: 'Systém',
  version: 'Verze',
  goVersion: 'Verze Go',
  gitClient: 'Klient Git',
  tmpPath: 'Cesta k dočasným souborům',
  homeDirMode: 'Režim domovského adresáře',
  scheduleTimezone: 'Časové pásmo harmonogramů',
  ansibleNotFound: 'Ansible nebyl na tomto serveru nalezen',
  database: 'Databáze',
  dbDialect: 'Dialekt',
  authentication: 'Ověřování',
  passwordLogin: 'Přihlášení heslem',
  emailOtp: 'Jednorázový kód e-mailem',
  oidcProviders: 'OpenID Connect',
  notifications: 'Oznámení',
  cluster: 'Cluster',
  highAvailability: 'Vysoká dostupnost',
  nodeId: 'ID uzlu',
  nodeCount: 'Počet uzlů',
  uiInstances: 'Instance UI',
  useRemoteRunner: 'Vzdálené runnery',
  globalRunners: 'Globální runnery',
  active2: 'aktivní',
  taskSettings: 'Nastavení úloh',
  maxParallelTasks: 'Max. počet paralelních úloh',
  maxTaskDuration: 'Max. doba trvání úlohy',
  maxTasksPerTemplate: 'Max. počet úloh na šablonu',
  unlimited: 'Bez omezení',
  featureFlags: 'Přepínače funkcí',
  nonAdminCanCreateProject: 'Uživatel bez role administrátora může vytvořit projekt',
};
